export default {
  preview: {
    label: 'Voorbeeld',
    tooltip: 'Bekijk de online bestelpagina in een nieuw tabblad.',
  },
  buttons: {
    visit_online_store: 'Online Shop',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Ordersportaal starten mislukt',
  },
};
